export const STORAGE_KEYS = {
  token: "TOKEN",
  credentials: "CREDENTIALS",
  userData: "USER_DATA",
  articleData: "ARTICLE_DATA",
};
